import { LibraryResourceCategory } from '../constants/library-category-cover.constant';

export type LibraryResourceItem = {
  availableIn: string[];
  category: LibraryResourceCategory;
  description: string;
  downloadUrl: string;
  id: string;
  title: string;
};

export const libraryData: LibraryResourceItem[] = [
  {
    id: 'advisor-agreement',
    title: 'Advisor Agreement',
    description:
      'An agreement for engaging external advisors, covering consultancy terms, equity compensation, responsibilities, and confidentiality obligations.',
    category: 'Company',
    availableIn: ['English'],
    downloadUrl: '/library/Advisor Agreement (Template).docx',
  },
  {
    id: 'founders-agreement',
    title: 'Founders Agreement',
    description:
      'An agreement between co-founders and the company that governs equity ownership, roles, vesting, decision-making, and exit provisions.',
    category: 'Company',
    availableIn: ['English'],
    downloadUrl: '/library/Founders Agreement (Template).docx',
  },
  {
    id: 'esop-grant-vesting-schedule',
    title: 'ESOP - Grant Vesting Schedule',
    description:
      'A grant agreement template for issuing share options to an individual participant with a time-based vesting schedule.',
    category: 'ESOPs',
    availableIn: ['English'],
    downloadUrl: '/library/ESOP - Grant Vesting Schedule (Template).docx',
  },
  {
    id: 'esop-board-resolution',
    title: 'ESOP - Board Resolution',
    description:
      'A board resolution template for formally adopting the ESOP plan and authorizing the issuance of options.',
    category: 'ESOPs',
    availableIn: ['English'],
    downloadUrl: '/library/ESOP - Board Resolution (Template).docx',
  },
  {
    id: 'esop-faq',
    title: 'ESOP - FAQ',
    description:
      'Document explaining how the ESOP works — covering vesting, exercise, leaver scenarios, and tax responsibilities.',
    category: 'ESOPs',
    availableIn: ['English'],
    downloadUrl: '/library/ESOP - FAQ.docx',
  },
  {
    id: 'esop-grant-performance-conditions',
    title: 'ESOP - Grant Performance Conditions',
    description:
      'A grant agreement template for issuing share options where vesting is tied to milestone or performance targets.',
    category: 'ESOPs',
    availableIn: ['English'],
    downloadUrl: '/library/ESOP - Grant Performance Conditions (Template).docx',
  },
  {
    id: 'esop-plan-terms',
    title: 'ESOP - Plan Terms',
    description:
      'Document that sets out the rules, definitions, and conditions under which the company grants share options to employees and advisors.',
    category: 'ESOPs',
    availableIn: ['English'],
    downloadUrl: '/library/ESOP - Plan Terms (Template).docx',
  },
  {
    id: 'capital-call-notice',
    title: 'Capital Call Notice',
    description:
      'A formal notice from a fund to its investors requesting the drawdown of committed capital for a specific investment purpose.',
    category: 'Operations',
    availableIn: ['English'],
    downloadUrl: '/library/Capital Call Notice (Template).docx',
  },
  {
    id: 'investment-introduction-agreement',
    title: 'Investment Introduction Agreement',
    description:
      'An agreement between a company and an introducer who refers potential investors, setting out fees and obligations.',
    category: 'Operations',
    availableIn: ['English'],
    downloadUrl: '/library/Investment Introduction Agreement (Template).docx',
  },
  {
    id: 'safe-cap-and-discount',
    title: 'SAFE (Cap and Discount)',
    description:
      'A Simple Agreement for Future Equity with a valuation cap and discount, used for early-stage convertible investment.',
    category: 'Fundraising',
    availableIn: ['English'],
    downloadUrl: '/library/SAFE - Cap and Discount (Template).docx',
  },
  {
    id: 'safe-side-letter',
    title: 'SAFE Side Letter',
    description:
      'A supplementary agreement to a SAFE that adds post-closing conditions, additional warranties, and most-favoured-nation protections for the investor.',
    category: 'Fundraising',
    availableIn: ['English'],
    downloadUrl: '/library/SAFE - Side Letter (Template).docx',
  },
  {
    id: 'series-a-subscription-agreement',
    title: 'Series A - Subscription Agreement',
    description:
      'The binding agreement through which investors subscribe for new shares in a Series A funding round.',
    category: 'Fundraising',
    availableIn: ['English'],
    downloadUrl: '/library/Series A Subscription Agreement (Template).docx',
  },
  {
    id: 'series-a-term-sheet',
    title: 'Series A - Term Sheet',
    description:
      'A term sheet outlining the indicative commercial terms for a Series A equity investment round.',
    category: 'Fundraising',
    availableIn: ['English'],
    downloadUrl: '/library/Series A Term Sheet (Template).docx',
  },
];
